import React from 'react';
import './Redeem.css';

// Imported custom icons
import CheckCircle from "../../assets/panelImages/redeem/complete_survey.svg";
import Coins from "../../assets/panelImages/redeem/earn_points.svg";
import Gift from "../../assets/panelImages/redeem/redeem.svg";

const StepCard = ({ icon, label }) => (
  <div className="step-card">
    <div className="step-icon">
      <img src={icon} alt={label} />
    </div>
    <div className="step-label">{label}</div>
  </div>
);

const Connector = () => (
  <div className="step-connector">
    <div className="step-connector-line"></div>
    <div className="step-connector-dot"></div>
    <div className="step-connector-line"></div>
  </div>
);

const RedeemSteps = () => {
  return (
    <>
    <div className="survey-steps-container">
      <StepCard icon={CheckCircle} label="Complete Survey" />
      <Connector />
      <StepCard icon={Coins} label="Earn Points" />
      <Connector />
      <StepCard icon={Gift} label="Redeem" />
    </div>

    <p className='redeem-note mt-2'> <b>Note:</b> Your earned points will become redeemable after qualifying the survey. To redeem the reward, the 
minimum redeemable points in your account must be <b>25000 points</b>.</p>
    </>

  );
};

export default RedeemSteps;
